import * as React from 'react';
import styled from 'styled-components';
// components
import { Spinner } from '../style/Spinner';

type Props = {
  isLoading?: boolean;
  error?: boolean | null;
  text?: string;
  color?: string;
  height?: number | string;
  zIndex?: number;
  onRetry?: () => void;
};

type ContainerProps = {
  height?: number | string;
  zIndex?: number;
};

const LoadingOverlay = styled.div<ContainerProps>`
  font-family: 'Work Sans, sans-serif';
  font-weight: 700;
  font-size: 16px;
  line-height: 18px;
  color: black;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  line-height: 50px;
  margin: 0;
  z-index: ${props => (props.zIndex !== undefined ? props.zIndex : 99)};
`;

const LoadingSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;

  h1 {
    margin: 0;
    font-size: 16px;
    line-height: 18px;
    letter-spacing: 1px;
  }
`;

const LoadingContainer = styled.div<ContainerProps>`
  position: ${props => (props.height ? 'relative' : 'inherit')};
  height: ${props => {
    if (typeof props.height === 'string') {
      return props.height;
    } else if (typeof props.height === 'number') {
      return `${props.height}px`;
    } else if (typeof props.height === 'undefined') {
      return 0;
    }
  }};
`;

export const LoadingIndicator = ({
  isLoading = false,
  error = false,
  text = 'Loading...',
  color,
  height,
  zIndex,
  onRetry,
}: Props) => {
  return (
    <LoadingContainer height={height}>
      {isLoading && !error && (
        <LoadingOverlay zIndex={zIndex}>
          <LoadingSection>
            <div>
              <Spinner color={color ? color : 'black'} />
            </div>

            <h1 style={{ color: color }}>{text}</h1>
          </LoadingSection>
        </LoadingOverlay>
      )}
      {error && (
        <LoadingOverlay zIndex={zIndex}>
          <LoadingSection
            style={{ cursor: onRetry ? 'pointer' : 'auto' }}
            onClick={() => onRetry && onRetry()}
          >
            <h1>Try Again...</h1>
          </LoadingSection>
        </LoadingOverlay>
      )}
    </LoadingContainer>
  );
};
